import { ReactNode } from "react";
import { useFeatureFlagsProvider } from "../hooks/useFeatureFlagsProvider";

interface IFeatureFlagsProviderProps {
  children: ReactNode;
}

export const FeatureFlagsProvider = ({ children }: IFeatureFlagsProviderProps) => {
  const LaunchDarklyProvider = useFeatureFlagsProvider();

  return <LaunchDarklyProvider>{children}</LaunchDarklyProvider>;
};
